import { Observable } from 'rxjs';
import { City, DataSourceResponse } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';


@Injectable()
export class CityService extends ApiService {
  endPoint = '/api/cities';
  create(model: City) {
    return this.http.post(`${this.commonBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: City) {
    return this.http.put(`${this.commonBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.commonBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<City> {
    return this.http.get<City>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }

  getCities(queryParams?: any): Observable<DataSourceResponse<City>> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}`, { params });
  }

  getCitiesByRegionCode(regionCode: string): Observable<City[]> {
    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}/region-code/${regionCode}/cities`);
  }

  getCitiesByRegion(regionId: string): Observable<City[]> {
    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}/region/${regionId}/cities`);
  }

  getCitiesByRegionMvd(mvdId: string): Observable<City[]> {
    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}/region-mvd/${mvdId}/cities`);
  }
}
